// 支付页接口
import ajax from '@/utils/ajax';

const urls = {
  reqCashierInfoUrl: '/web/v1/no-login-pay/cashier-desk-info', // 收银台初始化
  reqOrderValidationUrl: '/web/v1/no-login-pay/pay-verify', // 订单校验
  reqPayResultUrl: '/web/v1/no-login-pay/pay-result', // 查询支付状态
  reqPayImmediateUrl: '/web/v1/no-login-pay/immediate-payment', // 立即支付
  reqHuabeiInfoUrl: '/web/v1/no-login-pay/hb-payable', // 获取花呗详细分期信息
};

// 立即支付
export const reqPayImmediate = (requestParams) => ajax(urls.reqPayImmediateUrl, requestParams, 'POST');

// 订单产品校验
export const reqOrderValidation = (requestParams) => ajax(urls.reqOrderValidationUrl, requestParams);
// 支付信息初始化
export const reqPayInfo = (requestParams) => ajax(urls.reqCashierInfoUrl, requestParams);
// 花呗信息初始化
export const reqHuabeiInfo = (requestParams) => ajax(urls.reqHuabeiInfoUrl, requestParams);
// 查询支付状态
export const reqPayResult = (requestParams) => ajax(urls.reqPayResultUrl, requestParams);
